
// Simple slider for Products Bundle section
(function () {
  const initBundles = () => {
    if (!document.querySelectorAll) return;
    const containers = document.querySelectorAll('.products-bundle__swiper-container.swiper');

    if (!containers.length) return;
    if (!window.FoxTheme || !window.FoxTheme.Carousel) {
      console.warn('section-products-bundle: FoxTheme.Carousel not available');
      return;
    }

    containers.forEach((container) => {
      try {
        const wrapper = container.querySelector('.products-bundle__swiper-wrapper');
        if (!wrapper) return;

        // Ensure slides have the proper class
        Array.from(wrapper.children).forEach((child) => {
          child.classList.add('swiper-slide');
          // defensive inline fixes
          child.style.height = 'auto';
          child.style.display = 'block';
          child.style.alignSelf = 'flex-start';
        });

        // navigation scoped to container
        const next = container.querySelector('.swiper-button-next');
        const prev = container.querySelector('.swiper-button-prev');

        const options = {
          init: false,
          slidesPerView: 2,
          spaceBetween: 16,
          loop: false,
          freeMode: true,
          watchOverflow: true,
          grabCursor: true,
          threshold: 5,
          breakpoints: {
            768: {
              slidesPerView: 3
            }
          }
        };

        if (next || prev) {
          options.navigation = {};
          if (next) options.navigation.nextEl = next;
          if (prev) options.navigation.prevEl = prev;
        }

        // store instance on container so it can be referenced later if needed
        if (container.__bundleCarousel) {
          // already initialized — attempt to re-init slider if necessary
          return;
        }

        const carousel = new window.FoxTheme.Carousel(container, options);
        carousel.init();
        if (carousel.slider && typeof carousel.slider.init === 'function') {
          carousel.slider.init();
        }

        container.__bundleCarousel = carousel;
        // debug
        // console.info('section-products-bundle: carousel initialized', container);
      } catch (err) {
        console.error('section-products-bundle: failed to init carousel', err);
      }
    });
  };

  // prefer idle callback, else run on DOMContentLoaded
  if ('requestIdleCallback' in window) {
    requestIdleCallback(initBundles, { timeout: 1500 });
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundles);
  } else {
    initBundles();
  }
})();